import React from 'react';
import styled from 'styled-components';

import { ModalContainer, ModalButton, ModalSecondaryHeader, ModalClose } from 'shared/modals';

type KeepEditingModalProps = {
  onClickYes: () => void;
  isOpen: boolean;
  onClickNo: () => void;
  onClose: () => void;
};

export default function KeepEditingModal({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  onClickYes,
  onClickNo,
  onClose,
  isOpen = true,
}: KeepEditingModalProps): JSX.Element {
  return (
    <ModalContainer width='468px' padding='50px 40px 40px' isOpen={isOpen}>
      <ModalSecondaryHeader fontSize='18px'>You have unpublished changes!</ModalSecondaryHeader>

      <ButtonContainer>
        <ModalButton onClick={onClose} buttonContainerWidth='auto' width='100%'>
          Keep Editing
        </ModalButton>

        <ModalButton inverted onClick={onClickNo} buttonContainerWidth='auto' width='100%'>
          Leave without Saving
        </ModalButton>
      </ButtonContainer>

      <ModalClose onClick={onClose} />
    </ModalContainer>
  );
}

const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
`;
